import { render } from "./AddBanquePage.vue?vue&type=template&id=2a138a8a&ts=true"
import script from "./AddBanquePage.vue?vue&type=script&lang=ts"
export * from "./AddBanquePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__